module.exports = __webpack_public_path__ + "static/media/taotronics-tt-bh042.669bfc31.jpg";